var _path, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4C0 1.79086 1.79086 0 4 0H13C15.2091 0 17 1.79086 17 4V4.95855L20.5 2.93782C21.1667 2.55292 22 3.03405 22 3.80385V14.1962C22 14.966 21.1667 15.4471 20.5 15.0622L18.2194 13.7455L18.4362 13.5287C19.6163 12.3487 19.6163 10.4354 18.4362 9.25527C17.2561 8.07518 15.3428 8.07518 14.1627 9.25527L13.8641 9.55392L13.4281 9.11795C12.3106 8.00048 10.4988 8.00048 9.38138 9.11795C8.26391 10.2354 8.26391 12.0472 9.38138 13.1647L9.81735 13.6006L9.42833 13.9896C8.3324 15.0856 8.25425 16.8139 9.19388 18H4C1.79086 18 0 16.2091 0 14V4Z",
    fill: "#FF6060"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.5481,
    y: 11.0406,
    width: 2.50034,
    height: 9.99525,
    rx: 1.25017,
    transform: "rotate(-45 9.5481 11.0406)",
    fill: "#FF6060"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.615,
    y: 9.27332,
    width: 2.50034,
    height: 9.99525,
    rx: 1.25017,
    transform: "rotate(45 16.615 9.27332)",
    fill: "#FF6060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOff);
export default __webpack_public_path__ + "static/media/cameraOff.f41e254e6581c6141a68f64409277066.svg";
export { ForwardRef as ReactComponent };